/**
 * Event V2 Repository - GraphQL Mutations
 *
 * 3 mutation operations for Event primitive data modification.
 */

import { gql } from '@apollo/client';
import { EVENT_FIELDS_FRAGMENT } from './fragments';

export const CREATE_EVENT = gql`
  ${EVENT_FIELDS_FRAGMENT}
  mutation CreateEvent($tenantId: String!, $input: CreateEventInput!) {
    createEvent(tenantId: $tenantId, input: $input) {
      ...EventFields
    }
  }
`;

export const ARCHIVE_EVENTS = gql`
  mutation ArchiveEvents($tenantId: String!, $eventIds: [String!]!) {
    archiveEvents(tenantId: $tenantId, eventIds: $eventIds)
  }
`;

export const VERIFY_AND_REPAIR_CHAIN = gql`
  query VerifyAndRepairChain($tenantId: String!, $workflowInstanceId: String!) {
    verifyAndRepairChain(tenantId: $tenantId, workflowInstanceId: $workflowInstanceId) {
      chainValid
      totalEvents
      invalidEvents
      lastVerifiedAt
    }
  }
`;
